import { render, staticRenderFns } from "./pioneerList.vue?vue&type=template&id=2de2b976&scoped=true"
import script from "./pioneerList.vue?vue&type=script&lang=js"
export * from "./pioneerList.vue?vue&type=script&lang=js"
import style0 from "./pioneerList.vue?vue&type=style&index=0&id=2de2b976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2b976",
  null
  
)

export default component.exports